import {Select3dService} from '../../services/select-3d.service';
import {Injectable} from '@angular/core';
import {ComponentBase} from '../../component-base';

@Injectable()
export class DeselectByEscComponent extends ComponentBase {

  constructor(
    private selectSrvc: Select3dService
  ) {
    super();
  }

  keyDown(e: KeyboardEvent) {
    if (e.keyCode === 27) {
      this.selectSrvc.clearSelection();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/Shared/DeselectByEscComponent.ts